/* tslint:disable */

/**
 */
export class ViewProductSection_result {
    recAxis?: number[];
    mesAxis?: number[];
    resultValue?: number[][];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-product-section-_result.ts